module.exports = __webpack_public_path__ + "static/img/4.c5fd38c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/4/zh/4.png
// module id = kyHL
// module chunks = 0